import { render } from "./UserCard.vue?vue&type=template&id=078cf05a&ts=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__